import React from 'react'
import { AmortizationTable } from '@/types/management.types'
import { formatCurrency } from '../../../utils/currency'

interface AmortizationTableSectionProps {
  table?: AmortizationTable
  isLoading: boolean
}

// Mismo banner azul que LeaseConditionsSection.tsx ("Condiciones del
// arrendamiento"), pero con una tabla en vez de una lista de filas. El
// backend solo manda saldo_pendiente (saldo final) por mes, así que el
// saldo inicial de cada fila se calcula aquí: para el mes 1 es
// saldo_pendiente + capital_pagado de esa misma fila; para el resto es el
// saldo_pendiente del mes anterior. Sin columna de fecha por ahora — el
// backend todavía no la manda.
export const AmortizationTableSection: React.FC<
  AmortizationTableSectionProps
> = ({ table, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
        Cargando tabla de amortización...
      </div>
    )
  }

  const rows = table?.tabla_amortizacion
  if (!rows || rows.length === 0) {
    return (
      <div className="bg-white border border-olr-grey-2 rounded-lg p-12 text-center text-olr-body">
        Aún no hay tabla de amortización disponible.
      </div>
    )
  }

  return (
    <div className="w-full bg-white rounded-lg">
      <div className="bg-[#E4EFFF] px-6 py-3">
        <h2 className="text-sm font-semibold text-[#000000] uppercase tracking-wide text-center">
          Tabla de amortización
        </h2>
      </div>

      <div className="p-6 overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead>
            <tr className="border-b border-olr-grey-2 text-left text-olr-body">
              <th className="py-3 pr-4 font-bold text-gray-900">
                No. de pago
              </th>
              <th className="py-3 pr-4 font-bold text-gray-900">
                Saldo inicial
              </th>
              <th className="py-3 pr-4 font-bold text-gray-900">Capital</th>
              <th className="py-3 pr-4 font-bold text-gray-900">Interés</th>
              <th className="py-3 pr-4 font-bold text-gray-900">Renta</th>
              <th className="py-3 font-bold text-gray-900">Saldo final</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => {
              const saldoInicial =
                index === 0
                  ? row.saldo_pendiente + row.capital_pagado
                  : rows[index - 1].saldo_pendiente

              return (
                <tr key={row.mes} className="border-b border-olr-grey-2">
                  <td className="py-3 pr-4 text-gray-900">{row.mes}</td>
                  <td className="py-3 pr-4 text-gray-800">
                    {formatCurrency(saldoInicial)}
                  </td>
                  <td className="py-3 pr-4 text-gray-800">
                    {formatCurrency(row.capital_pagado)}
                  </td>
                  <td className="py-3 pr-4 text-gray-800">
                    {formatCurrency(row.interes_pagado)}
                  </td>
                  <td className="py-3 pr-4 text-gray-800">
                    {formatCurrency(row.renta_mensual_calculada)}
                  </td>
                  <td className="py-3 text-gray-800">
                    {formatCurrency(row.saldo_pendiente)}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AmortizationTableSection
